import React, { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from '../common/DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata,Fetchupdatequery } from '../../../services/process/BRS1/brsService7';
import { CreateData} from '../../../services/process/process_data/process_data';
import { Icon } from 'semantic-ui-react';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";


function PoCreation() {
  const INSTITUTION_TABLE_CANDIDATES = ["institute_master", "institute_master"];
  const EVENT_TABLE_NAME = "event_types";
  const EVENT_MASTER_TABLE_NAME = "events";
  const [formData, setFormData] = useState({});
  const [eventFormData, setEventFormData] = useState({});
  const [eventMasterFormData, setEventMasterFormData] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [fields, setFields] = useState(null);
  const [eventFields, setEventFields] = useState(null);
  const [eventMasterFields, setEventMasterFields] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [eventRowData, setEventRowData] = useState([]);
  const [eventMasterRowData, setEventMasterRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [eventColumnDefs, setEventColumnDefs] = useState([]);
  const [eventMasterColumnDefs, setEventMasterColumnDefs] = useState([]);
  const [isDiv1Open, setIsDiv1Open] = useState(true);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [eventSearchText, setEventSearchText] = useState('');
  const [eventMasterSearchText, setEventMasterSearchText] = useState('');
  const [error, setError] = useState(null);
  const [filterconditions,setFilterconditions] =  useState([{"is_active" : 1}]);
  const [editMode, setEditMode] = useState(false); // State to track if in edit mode
  const [eventEditMode, setEventEditMode] = useState(false); // State to track if in edit mode
  const [eventMasterEditMode, setEventMasterEditMode] = useState(false); // State to track if in edit mode
  const toggleDiv1 = () => setIsDiv1Open(!isDiv1Open);

  const fetchInstitutionData = async () => {
    setLoading(true);
    try {
      await Promise.all([
        fetchInstitutionFields(),
        fetchInstitutionRows(),
        fetchEventFields(),
        fetchEventRows(),
        fetchEventMasterFields(),
        fetchEventMasterRows(),
      ]);
    } finally {
      setLoading(false);
    }
  };

  const fetchEventData = async () => {
    await Promise.all([
      fetchEventFields(),
      fetchEventRows(),
    ]);
  };

  const fetchEventMasterData = async () => {
    await Promise.all([
      fetchEventMasterFields(),
      fetchEventMasterRows(),
    ]);
  };

  useEffect(() => {
  fetchInstitutionData();
  }, []);

  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  const normalizeInstitutionRow = (row) => ({
    ...row,
    primary_id: row.primary_id ?? row.id ?? row.institution_master_id ?? null,
  });

  const normalizeEventRow = (row) => ({
    ...row,
    primary_id: row.primary_id ?? row.id ?? row.event_type_id ?? null,
  });

  const normalizeEventMasterRow = (row) => ({
    ...row,
    primary_id: row.primary_id ?? row.id ?? row.event_master_id ?? null,
  });

  const fetchInstitutionFields = async () => {
    const payload = { headerconfig_id: 109, filterconditions: filterconditions };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data.fields?.length) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
          sortable: true,
          filter: true,
          resizable: true,
        }));

        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer', color: '#4969ab' }}
              onClick={() => handleInstitutionEditClick(params.data)}
            />
          ),
          width: 100,
        });

        setFields(data.fields);
        setColumnDefs(columns);
      }
    } catch (error) {
      console.error("Error fetching institution fields:", error);
      setError("Error fetching institution fields");
    }
  };

  const fetchInstitutionRows = async () => {
    const FileUploadCredentials = Fetchexecutequery();

    for (const tableName of INSTITUTION_TABLE_CANDIDATES) {
      try {
        const payload = {
          query: `SELECT * FROM education.${tableName} WHERE is_active = 1 ORDER BY 1 DESC;`,
        };
        const response = await axios.post(
          FileUploadCredentials[1],
          payload,
          FileUploadCredentials[0]
        );

        const data = (response.data || []).map(normalizeInstitutionRow);
        setRowData(data);
        return;
      } catch (error) {
        console.error(`Error fetching institution rows from ${tableName}:`, error);
      }
    }

    setError("Error fetching institution rows");
  };

  const fetchEventFields = async () => {
    const payload = { headerconfig_id: 110, filterconditions: filterconditions };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data.fields?.length) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
          sortable: true,
          filter: true,
          resizable: true,
        }));

        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer', color: '#4969ab' }}
              onClick={() => handleEventEditClick(params.data)}
            />
          ),
          width: 100,
        });

        setEventFields(data.fields);
        setEventColumnDefs(columns);
      }
    } catch (error) {
      console.error("Error fetching event fields:", error);
      setError("Error fetching event fields");
    }
  };

  const fetchEventRows = async () => {
    const FileUploadCredentials = Fetchexecutequery();

    try {
      const payload = {
        query: `SELECT * FROM education.${EVENT_TABLE_NAME} WHERE is_active = 1 ORDER BY 1 DESC;`,
      };
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = (response.data || []).map(normalizeEventRow);
      setEventRowData(data);
    } catch (error) {
      console.error("Error fetching event rows:", error);
      setError("Error fetching event rows");
    }
  };

  const fetchEventMasterFields = async () => {
    const payload = { headerconfig_id: 111, filterconditions: filterconditions };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data.fields?.length) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
          sortable: true,
          filter: true,
          resizable: true,
        }));

        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer', color: '#4969ab' }}
              onClick={() => handleEventMasterEditClick(params.data)}
            />
          ),
          width: 100,
        });

        setEventMasterFields(data.fields);
        setEventMasterColumnDefs(columns);
      }
    } catch (error) {
      console.error("Error fetching event master fields:", error);
      setError("Error fetching event master fields");
    }
  };

  const fetchEventMasterRows = async () => {
    const FileUploadCredentials = Fetchexecutequery();

    try {
      const payload = {
        query: `SELECT * FROM education.${EVENT_MASTER_TABLE_NAME} WHERE is_active = 1 ORDER BY 1 DESC;`,
      };
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = (response.data || []).map(normalizeEventMasterRow);
      setEventMasterRowData(data);
    } catch (error) {
      console.error("Error fetching event master rows:", error);
      setError("Error fetching event master rows");
    }
  };

  const handleInstitutionEditClick = (row) => {
    const cleanedRow = Object.fromEntries(
      Object.entries(normalizeInstitutionRow(row)).filter(([key]) => key !== "Sl.No")
    );

    setFormData(cleanedRow);
    setEditMode(true);
  };

  const resetInstitutionForm = () => {
    setFormData({});
    setEditMode(false);
  };

  const handleEventEditClick = (row) => {
    const cleanedRow = Object.fromEntries(
      Object.entries(normalizeEventRow(row)).filter(([key]) => key !== "Sl.No")
    );

    setEventFormData(cleanedRow);
    setEventEditMode(true);
  };

  const resetEventForm = () => {
    setEventFormData({});
    setEventEditMode(false);
  };

  const handleEventMasterEditClick = (row) => {
    const cleanedRow = Object.fromEntries(
      Object.entries(normalizeEventMasterRow(row)).filter(([key]) => key !== "Sl.No")
    );

    setEventMasterFormData(cleanedRow);
    setEventMasterEditMode(true);
  };

  const resetEventMasterForm = () => {
    setEventMasterFormData({});
    setEventMasterEditMode(false);
  };

  const refreshInstitutionGrid = async () => {
    await fetchInstitutionRows();
  };

  const refreshEventGrid = async () => {
    await fetchEventRows();
  };

  const refreshEventMasterGrid = async () => {
    await fetchEventMasterRows();
  };

const handleTabChange1 = (index) => {
  setActiveTab(index);
  console.log("User switched to tab:", index);
  
  // Perform specific logic based on tab
  if (index === 1) {
    fetchEventData();
  } else if (index === 2) {
    fetchEventMasterData();
  }
};


  const createPayload = (database, table, formData) => ({
    database,
    table,
    formData,
  });

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

const formatDateTime = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const pad = (n, size = 2) => String(n).padStart(size, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
         `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.000000`;
};

  const handleCreate = async () => {
    const cleanedFormData = Object.fromEntries(
      Object.entries(formData).filter(([key]) => key !== "primary_id" && key !== "id")
    );

    const createCredentials = CreateData();

    for (const tableName of INSTITUTION_TABLE_CANDIDATES) {
      try {
        const createPayloadData = createPayload(
          "education",
          tableName,
          cleanedFormData
        );
        await axios.post(createCredentials[1], createPayloadData, createCredentials[0]);
        await refreshInstitutionGrid();
        resetInstitutionForm();
        return;
      } catch (error) {
        console.error(`Error creating institution in ${tableName}:`, error);
      }
    }

    setError("Error creating institution");
  };

  const handleUpdate = async () => {
    const recordKey = formData.primary_id != null
      ? "primary_id"
      : formData.id != null
        ? "id"
        : "primary_id";
    const recordId = formData[recordKey];
    if (!recordId) {
      setError("Missing institution record id for update");
      return;
    }

    const updatedFormData = Object.fromEntries(
      Object.entries(formData).filter(([key]) => key !== "primary_id" && key !== "id" && key !== "institution_master_id")
    );

    const FileUploadCredentials = Fetchupdatequery();

    for (const tableName of INSTITUTION_TABLE_CANDIDATES) {
      try {
        const payload = {
          schema_name: "education",
          table: tableName,
          set_column: updatedFormData,
          where: [{ [recordKey]: recordId }],
        };
        await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
        await refreshInstitutionGrid();
        resetInstitutionForm();
        return;
      } catch (error) {
        console.error(`Error updating institution in ${tableName}:`, error);
      }
    }

    setError("Error updating institution");
  };

  const handleEventCreate = async () => {
    const cleanedFormData = Object.fromEntries(
      Object.entries(eventFormData).filter(([key]) => key !== "primary_id" && key !== "id")
    );

    const createCredentials = CreateData();

    try {
      const createPayloadData = createPayload(
        "education",
        EVENT_TABLE_NAME,
        cleanedFormData
      );
      await axios.post(createCredentials[1], createPayloadData, createCredentials[0]);
      await refreshEventGrid();
      resetEventForm();
    } catch (error) {
      console.error("Error creating event type:", error);
      setError("Error creating event type");
    }
  };

  const handleEventUpdate = async () => {
    const recordId = eventFormData.primary_id ?? eventFormData.id ?? eventFormData.event_type_id;
    if (!recordId) {
      setError("Missing event type record id for update");
      return;
    }

    const updatedFormData = Object.fromEntries(
      Object.entries(eventFormData).filter(([key]) => key !== "primary_id" && key !== "id" && key !== "event_type_id")
    );

    const FileUploadCredentials = Fetchupdatequery();

    try {
      const payload = {
        schema_name: "education",
        table: EVENT_TABLE_NAME,
        set_column: updatedFormData,
        where: [{ primary_id: recordId }],
      };
      await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
      await refreshEventGrid();
      resetEventForm();
    } catch (error) {
      console.error("Error updating event type:", error);
      setError("Error updating event type");
    }
  };

  const handleEventMasterCreate = async () => {
    const cleanedFormData = Object.fromEntries(
      Object.entries(eventMasterFormData).filter(([key]) => key !== "primary_id" && key !== "id")
    );

    const createCredentials = CreateData();

    try {
      const createPayloadData = createPayload(
        "education",
        EVENT_MASTER_TABLE_NAME,
        cleanedFormData
      );
      await axios.post(createCredentials[1], createPayloadData, createCredentials[0]);
      await refreshEventMasterGrid();
      resetEventMasterForm();
    } catch (error) {
      console.error("Error creating event master:", error);
      setError("Error creating event master");
    }
  };

  const handleEventMasterUpdate = async () => {
    const recordId = eventMasterFormData.primary_id ?? eventMasterFormData.id ?? eventMasterFormData.event_master_id;
    if (!recordId) {
      setError("Missing event master record id for update");
      return;
    }

    const updatedFormData = Object.fromEntries(
      Object.entries(eventMasterFormData).filter(([key]) => key !== "primary_id" && key !== "id" && key !== "event_master_id")
    );

    const FileUploadCredentials = Fetchupdatequery();

    try {
      const payload = {
        schema_name: "education",
        table: EVENT_MASTER_TABLE_NAME,
        set_column: updatedFormData,
        where: [{ primary_id: recordId }],
      };
      await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
      await refreshEventMasterGrid();
      resetEventMasterForm();
    } catch (error) {
      console.error("Error updating event master:", error);
      setError("Error updating event master");
    }
  };

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEventInputChange = (name, value) => {
    setEventFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEventMasterInputChange = (name, value) => {
    setEventMasterFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };

  const onEventFilterTextChange = (event) => {
    const { value } = event.target;
    setEventSearchText(value);
  };

  const onEventMasterFilterTextChange = (event) => {
    const { value } = event.target;
    setEventMasterSearchText(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

  const handleEventSubmit = (e) => {
    e.preventDefault();
    if (eventEditMode) {
      handleEventUpdate();
    } else {
      handleEventCreate();
    }
  };

  const handleEventMasterSubmit = (e) => {
    e.preventDefault();
    if (eventMasterEditMode) {
      handleEventMasterUpdate();
    } else {
      handleEventMasterCreate();
    }
  };

 if (loading) return <LoaderComponent loaderOpen={true}/>;

  return (
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab", fontSize: '18px' }}>
        Master Details
      </h2>


            <Tabs selectedIndex={activeTab} onSelect={(index) => handleTabChange1(index)}>
        <TabList>
          <Tab>Institutions</Tab>
          <Tab>Event Type</Tab>
          <Tab>Event Master</Tab>
        </TabList>

      {error && <div style={{ color: "red" }}>{error}</div>}

       <TabPanel>
          <div style={{ margin: "10px" }}>
        {isDiv1Open && (
            <>
              {editMode && (
                <div
                  style={{
                    background: "#fff8f0",
                    border: "1px solid #f0c080",
                    borderRadius: 4,
                    padding: "6px 12px",
                    marginBottom: 10,
                    color: "#b7730a",
                    fontSize: 12,
                    fontWeight: 600,
                  }}
                >
                  Editing an institution. Update the details and click Submit.
                </div>
              )}
              <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange} />
            </>
        )}


            <div className="submit-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px" }}>
              <input
                className="search-input"
                type="text"
                placeholder="Search..."
                value={searchText}
                onChange={onFilterTextChange}
                style={{
                  width: "30%",
                  backgroundColor: "white",
                  marginRight: "8px",
                  marginTop: "0",
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                }}
              />
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "auto" }}>
                {editMode ? (
                  <button type="button" className="submit-btn" onClick={resetInstitutionForm} style={{ background: "#888" }}>
                    Cancel
                  </button>
                ) : null}
                <button type="submit" className="submit-btn" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          <div
            className="ag-theme-alpine"
            style={{ height: "480px", width: "100%", marginTop: "12px" }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              pagination={true}
              paginationPageSize={10}
              filter={true}
              quickFilterText={searchText}
            />
          </div>
          </div>
        </TabPanel>

        <TabPanel>
          <div style={{ margin: "10px" }}>
            {eventEditMode && (
              <div
                style={{
                  background: "#fff8f0",
                  border: "1px solid #f0c080",
                  borderRadius: 4,
                  padding: "6px 12px",
                  marginBottom: 10,
                  color: "#b7730a",
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                Editing an event type. Update the details and click Submit.
              </div>
            )}
            <DynamicForm fields={eventFields} formData={eventFormData} onInputChange={handleEventInputChange} />

            <div className="submit-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px" }}>
              <input
                className="search-input"
                type="text"
                placeholder="Search..."
                value={eventSearchText}
                onChange={onEventFilterTextChange}
                style={{
                  width: "30%",
                  backgroundColor: "white",
                  marginRight: "8px",
                  marginTop: "0",
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                }}
              />
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "auto" }}>
                {eventEditMode ? (
                  <button type="button" className="submit-btn" onClick={resetEventForm} style={{ background: "#888" }}>
                    Cancel
                  </button>
                ) : null}
                <button type="submit" className="submit-btn" onClick={handleEventSubmit}>
                  Submit
                </button>
              </div>
            </div>

            <div
              className="ag-theme-alpine"
              style={{ height: "480px", width: "100%", marginTop: "12px" }}
            >
              <AgGridReact
                rowData={eventRowData}
                columnDefs={eventColumnDefs}
                pagination={true}
                paginationPageSize={10}
                filter={true}
                quickFilterText={eventSearchText}
              />
            </div>
          </div>
        </TabPanel>

        <TabPanel>
          <div style={{ margin: "10px" }}>
            {eventMasterEditMode && (
              <div
                style={{
                  background: "#fff8f0",
                  border: "1px solid #f0c080",
                  borderRadius: 4,
                  padding: "6px 12px",
                  marginBottom: 10,
                  color: "#b7730a",
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                Editing an event master. Update the details and click Submit.
              </div>
            )}
            <DynamicForm
              fields={eventMasterFields}
              formData={eventMasterFormData}
              onInputChange={handleEventMasterInputChange}
            />

            <div className="submit-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px" }}>
              <input
                className="search-input"
                type="text"
                placeholder="Search..."
                value={eventMasterSearchText}
                onChange={onEventMasterFilterTextChange}
                style={{
                  width: "30%",
                  backgroundColor: "white",
                  marginRight: "8px",
                  marginTop: "0",
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                }}
              />
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "auto" }}>
                {eventMasterEditMode ? (
                  <button type="button" className="submit-btn" onClick={resetEventMasterForm} style={{ background: "#888" }}>
                    Cancel
                  </button>
                ) : null}
                <button type="submit" className="submit-btn" onClick={handleEventMasterSubmit}>
                  Submit
                </button>
              </div>
            </div>

            <div
              className="ag-theme-alpine"
              style={{ height: "480px", width: "100%", marginTop: "12px" }}
            >
              <AgGridReact
                rowData={eventMasterRowData}
                columnDefs={eventMasterColumnDefs}
                pagination={true}
                paginationPageSize={10}
                filter={true}
                quickFilterText={eventMasterSearchText}
              />
            </div>
          </div>
        </TabPanel>

      </Tabs>

    </div>
  );
}

export default PoCreation;
